/* aeb1716ae9266868e45049df903a45b5bf58b970
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestOrderShareMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String'];
}>;


export type RequestOrderShareMutation = { __typename?: 'Mutation', requestOrderShare: { __typename?: 'RequestOrderShare', key?: string | undefined } };


export const RequestOrderShareDocument = gql`
    mutation RequestOrderShare($orderId: String!) {
  requestOrderShare(orderId: $orderId) {
    key
  }
}
    `;
export type RequestOrderShareMutationFn = Apollo.MutationFunction<RequestOrderShareMutation, RequestOrderShareMutationVariables>;

/**
 * __useRequestOrderShareMutation__
 *
 * To run a mutation, you first call `useRequestOrderShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrderShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrderShareMutation, { data, loading, error }] = useRequestOrderShareMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useRequestOrderShareMutation(baseOptions?: Apollo.MutationHookOptions<RequestOrderShareMutation, RequestOrderShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOrderShareMutation, RequestOrderShareMutationVariables>(RequestOrderShareDocument, options);
      }
export type RequestOrderShareMutationHookResult = ReturnType<typeof useRequestOrderShareMutation>;
export type RequestOrderShareMutationResult = Apollo.MutationResult<RequestOrderShareMutation>;
export type RequestOrderShareMutationOptions = Apollo.BaseMutationOptions<RequestOrderShareMutation, RequestOrderShareMutationVariables>;